import { IconButton } from "@material-ui/core";
// MUI Stuff
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTheme } from "@material-ui/core/styles";
import makeStyles from "@material-ui/core/styles/makeStyles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(() => ({
  padLoading: {
    paddingLeft: 0,
  },
}));

function CircularButton(props) {
  const { children, isLoading, btnType, ...rest } = props;
  const classes = useStyles();
  const theme = useTheme();
  return (
    <>
      <IconButton
        {...rest}
        type={btnType || ""}
        variant={props.variant || "contained"}
        color={props.color || "primary"}
        disabled={isLoading || props.disabled}
        size="small"
        style={{
          backgroundColor:
            isLoading || props.disabled
              ? theme.palette.grey[300]
              : theme.palette.primary.main,
        }}
      >
        {isLoading && <CircularProgress size={20} />}
        {!isLoading && <ArrowForwardIcon htmlColor="white" fontSize="small" />}
      </IconButton>
    </>
  );
}

CircularButton.propTypes = {
  children: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  btnType: PropTypes.string,
};

export default CircularButton;
